import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api from '../services/api';

export const useAuthStore = create(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      isLoading: false,
      // Empresa activa del System Owner (Multi Company). null = ve todas.
      // Los demás roles ya están scopeados por su propio company_id, no usan esto.
      selectedCompanyId: null,
      setSelectedCompanyId: (id) => set({ selectedCompanyId: id }),

      login: async (username, password) => {
        set({ isLoading: true });
        try {
          const { data } = await api.post('/auth/login', { username, password });
          api.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
          set({ token: data.token, user: data.user, isLoading: false });
          return data;
        } catch (err) {
          set({ isLoading: false });
          throw err;
        }
      },

      logout: async () => {
        try {
          await api.post('/auth/logout');
        } catch (_) {}
        delete api.defaults.headers.common['Authorization'];
        set({ token: null, user: null, selectedCompanyId: null, impersonatorSession: null });
      },

      updateUser: (updates) => set(state => ({
        user: { ...state.user, ...updates },
      })),

      setToken: (token) => {
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        set({ token });
      },

      // Soporte (Multi Company): el System Owner "entra como" un usuario de
      // una empresa. Guarda su propia sesión para poder volver a ella.
      impersonatorSession: null,
      startImpersonation: (token, user) => {
        const { token: prevToken, user: prevUser } = get();
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        set({ token, user, impersonatorSession: { token: prevToken, user: prevUser }, selectedCompanyId: null });
      },
      stopImpersonation: () => {
        const orig = get().impersonatorSession;
        if (!orig) return;
        api.defaults.headers.common['Authorization'] = `Bearer ${orig.token}`;
        set({ token: orig.token, user: orig.user, impersonatorSession: null });
      },
    }),
    {
      name: 'pbx-auth',
      partialize: (state) => ({
        token: state.token, user: state.user, selectedCompanyId: state.selectedCompanyId,
        impersonatorSession: state.impersonatorSession,
      }),
    }
  )
);
